import { getMultiselectValidatorList } from 'app/validators';
import { EBookInputType, TGetBookInput } from '../shared';
import { IBookMultiselectInput, IBookMultiselectInputOption } from './types';

export const getBookMultiselectInputOptionData = <
  T extends B,
  B extends IBookMultiselectInputOption,
>(params: T): Readonly<B & T> => ({
  ...params
} as const)

export const getBookMultiselectInputData: TGetBookInput<IBookMultiselectInput, 'type' | 'validator'>
  = (params) => ({
    ...params,
    type: EBookInputType.multiselect,
    validator: getMultiselectValidatorList(params.min, params.max),
  } as const);
